import React, { useState } from "react";
import { GoogleLogin } from '@react-oauth/google';

const GoogleLoginButton = () => {
  const [loading, setLoading] = useState(false);
    const handleLoginSuccess = (response) => {
        setLoading(true);
        console.log(response);
        const idToken = response.credential;
        fetch('/api/users/google-login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ idToken })
        })
        .then(response => response.json())
        .then(data => {
            console.log('User logged in:', data);
            localStorage.setItem("currentUser", JSON.stringify(data));
            // const redirectUrl = sessionStorage.getItem('redirectUrl');
            // if (redirectUrl) {
            //     // Clear the stored redirect URL
            //     sessionStorage.removeItem('redirectUrl');

            //     // Redirect the user back to the original URL
            //     window.location.href=redirectUrl;
            // } else {
            //     // If no redirect URL is stored, redirect to a default route
            // window.location.href = "/home";      }
            window.location.href = "/home";
            // Handle successful login in your client-side application
        })
        .catch(error => {
            console.error(error);
            // Handle login failure in your client-side application
        });
        setLoading(false);
    };

    return (
    <>
        {loading && <div>Loading...</div>}
        <GoogleLogin
            onSuccess={handleLoginSuccess}
            shape="rectangle"
            width='100'
            size='large'
            text='continue_with'
            theme="filled_blue"
            logo_alignment="center"
            locale='en-GB'
            
            onError={() => {
              console.log('Login Failed');
            }}
            useOneTap
          />
          </>

          
    )
}

export default GoogleLoginButton;
